/** @typedef	{import('./Props').default} Props */

import React from 'react';
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard';
import SubscriptionCardEnterprise from '../SubscriptionCard/SubscriptionCardEnterprise';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionPlans(props) {
	return (
		<section className="flex flex-col gap-4 lg:grid lg:grid-cols-3 ">
			{props?.tiers?.map((tier) => {
				if (tier.title === 'enterprise') {
					return (
						<SubscriptionCardEnterprise
							checkoutRole={props?.checkoutRole}
							isGettingData={props?.isGettingData}
							key={tier.title}
							paymentLinks={props?.paymentLinks}
							tier={tier}
						/>
					);
				}

				return (
					<SubscriptionCard
						checkoutRole={props?.checkoutRole}
						isGettingData={props?.isGettingData}
						key={tier.title}
						paymentLinks={props?.paymentLinks}
						tier={tier}
					/>
				);
			})}
		</section>
	);
}

export default React.memo(SubscriptionPlans);
